<div class="chart_content">
    <div class="chart_content-innerbox" *ngIf="mixedChartData">
        <div class="chart_content-stack custom-scrollv2">
            <div class="stacks" [ngClass]="{'active': selectedType == lLegend.name}" (click)="set(lLegend.name)"
                *ngFor="let lLegend of leftLagend; let i = index">
                {{ lLegend.name }}
            </div>
        </div>

        <div class="chart_content-graph position-relative">
            <h3 class="title-text mb-4">{{selectedType}}</h3>
            <div class="chart-canvas_marker">

                <div class="d-flex align-items-baseline" *ngFor="let item of legends; let i = index">
                    <div class="marker marker-color{{i}}"></div>  
                    <div>
                        <div>{{item.name}} {{item?.year}} </div>
                         
                        <div>
                            {{
                            (selectedType === 'Spent' || selectedType === 'Revenue' || selectedType === 'Profit' ||
                            selectedType === 'Fees' || selectedType === 'COGS' || selectedType === 'Return Amount') ?
                            ((item.sum || 0) | currency) :
                            (selectedType === 'Margin' || selectedType === 'ROI' || selectedType === 'ACOS' ||
                            selectedType === 'TACOS' || selectedType === 'Return Rate') ?
                            (item.sum || 0) + '%' :
                            (item.sum || 0) | number
                            }}
                        </div>
                    </div>

                </div>
            </div>
            <ng-container *ngIf="!loading">
                <div id="mixedChartSalesID" style="position: relative; height: 257px;">
                        <app-lines-chart [id]="'mixedChartSalesID'" 
                        [isKpiSalesLineGraph]="true"
                        [isShowPercentageOnly]="true"
                        [yAxisLabelType]= " (selectedType == 'Spent' || selectedType == 'Revenue' || selectedType == 'Profit' || selectedType == 'Fees' ||
                        selectedType == 'COGS'|| selectedType == 'Return Amount')  ? 'dollar'
                        : (selectedType == 'Margin' || selectedType =='ROI' || selectedType == 'ACOS' || selectedType == 'TACOS' || selectedType == 'Return Rate' ) ? 'percentage'
                        : '' "
                        [yAxisLabelType1]="'percentage'"
                        [tickInterval]="tickInterval" [isPosition]="true" [data]="mixedChartData"
                          [chartColors]="mixedChartColor" [labels]="mixedChartLabel">
                      </app-lines-chart>
                </div>
            </ng-container>
                <ng-container *ngIf="loading">
                    <div class="loader" >
                        <img src="assets/images/nineyard-loading.gif" />
                    </div>
                </ng-container>
        </div>

        <div class="chart_content-actions">
            <form [formGroup]="dateForm">
                <div class="form-action d-flex">
                    <div class="form-action_compare">
                        <div class="title">Compare with</div>
                        <mat-radio-group formControlName="selectDate" class="custom-mat-radio">
                            <mat-radio-button class="mat-primary" [value]="'w'">Weekly</mat-radio-button>
                            <mat-radio-button class="mat-primary" [value]="'m'">Monthly </mat-radio-button>
                            <mat-radio-button class="mat-primary" [value]="'q'">Quarterly </mat-radio-button>
                            <mat-radio-button class="mat-primary" [value]="'y'">Yearly </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div class="form-action_weekly">
                        <div class="title">{{selectedDate == 'w' ? 'Weekly' : selectedDate == 'm' ? 'Monthly' :
                            selectedDate == 'q' ? 'Quarterly' : 'Yearly'}}
                        </div>
                        <div class="form-action_check custom-scrollv2">
                            <div class="d-flex flex-column align-items-start" *ngIf="dateForm.get('selectDate').value == 'w'">
                                <div class="form-action_checkSelection" *ngFor="let selectedDay of selectedWeek ; let i = index">
                                    <mat-checkbox class="mat-checkbox-sm" (change)="selectWeek($event,selectedDay,i)"
                                        [checked]="selectedDay.checked">{{selectedDay.label}}</mat-checkbox>
                                </div>
                            </div>

                            <div class="d-flex flex-column align-items-start" *ngIf="dateForm.get('selectDate').value == 'm'">
                                <div class="form-action_checkSelection" *ngFor="let selectedMonth of months; let i = index">
                                    <mat-checkbox class="mat-checkbox-sm" (change)="selectMonth($event,selectedMonth)"
                                        [checked]="selectedMonth.checked">{{selectedMonth.name}}
                                        {{selectedMonth.year}}</mat-checkbox>
                                </div>
                            </div>

                            <div class="d-flex flex-column align-items-start" *ngIf="dateForm.get('selectDate').value == 'q'">
                                <div class="form-action_checkSelection" *ngFor="let selectedQuarterly of quartely">
                                    <mat-checkbox class="mat-checkbox-sm"
                                        (change)="selectQuartely($event,selectedQuarterly)"
                                        [checked]="selectedQuarterly.checked">
                                        {{selectedQuarterly.months}}</mat-checkbox>
                                </div>
                            </div>

                            <div class="d-flex flex-column align-items-start" *ngIf="dateForm.get('selectDate').value == 'y'">
                                <div class="form-action_checkSelection" *ngFor="let selectedYearly of years">
                                    <mat-checkbox class="mat-checkbox-sm" (change)="selectYearly($event,selectedYearly)"
                                        [checked]="selectedYearly.checked">
                                        {{selectedYearly.name}}</mat-checkbox>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>